(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-review-header"]) return;
  try {
    
function addConsultationSummary() {
  const productMarker = document.querySelector('shopify-payment-terms[variant-id="49550743437568"]');
  const sticky = document.querySelector('.product-info__sticky');
  const description = document.querySelector('.product-description');

  if (!productMarker || !sticky || !description || sticky.querySelector('.consultation-summary-card')) return;

  const bookingButton = Array.from(sticky.querySelectorAll('button')).find((button) => button.textContent.trim().toLowerCase() === 'book now');
  const bookingBlock = bookingButton ? bookingButton.closest('.product-info__block') : null;
  const summaryParagraphs = Array.from(description.children).filter((element) => element.tagName === 'P').slice(0, 2);

  if (!bookingBlock || summaryParagraphs.length === 0) return;

  const summary = document.createElement('div');
  summary.className = 'consultation-summary-card';
  summaryParagraphs.forEach((paragraph) => summary.appendChild(paragraph.cloneNode(true)));
  bookingBlock.before(summary);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addConsultationSummary);
} else {
  addConsultationSummary();
}

const consultationObserver = new MutationObserver(() => {
  addConsultationSummary();

  if (document.querySelector('.consultation-summary-card')) {
    consultationObserver.disconnect();
  }
});

consultationObserver.observe(document.documentElement, { childList: true, subtree: true });
setTimeout(() => consultationObserver.disconnect(), 10000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resource-library"] && !Shopify.designMode) return;
  try {
    
  const initializeResourceLibraries = () => {
    document.querySelectorAll('[data-resource-library]').forEach((library) => {
      if (library.dataset.initialized === 'true') return;
      library.dataset.initialized = 'true';
      const search = library.querySelector('[data-resource-search]');
      const clear = library.querySelector('[data-resource-clear]');
      const cards = Array.from(library.querySelectorAll('[data-resource-card]'));
      const count = library.querySelector('[data-resource-count]');
      const empty = library.querySelector('[data-resource-empty]');
      const reset = library.querySelector('[data-reset-filters]');
      const emptyReset = library.querySelector('[data-empty-reset]');
      const labels = count.textContent.trim().split(' ').slice(1).join(' ');
      const state = { format: 'all', topic: 'all' };

      const update = () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const matchesSearch = !query || card.dataset.search.toLowerCase().includes(query);
          const matchesFormat = state.format === 'all' || card.dataset.format === state.format;
          const topics = card.dataset.topics.split(' ');
          const matchesTopic = state.topic === 'all' || topics.includes(state.topic);
          const show = matchesSearch && matchesFormat && matchesTopic;
          card.hidden = !show;
          if (show) visible += 1;
        });
        count.textContent = `${visible} ${labels}`;
        empty.hidden = visible !== 0;
        clear.hidden = query.length === 0;
        reset.hidden = query.length === 0 && state.format === 'all' && state.topic === 'all';
      };

      const resetAll = () => {
        search.value = '';
        state.format = 'all';
        state.topic = 'all';
        library.querySelectorAll('[data-filter-group]').forEach((group) => {
          group.querySelectorAll('[data-filter]').forEach((button) => {
            const active = button.dataset.filter === 'all';
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        });
        update();
        search.focus();
      };

      search.addEventListener('input', update);
      clear.addEventListener('click', () => { search.value = ''; update(); search.focus(); });
      library.querySelectorAll('[data-filter-group]').forEach((group) => {
        group.addEventListener('click', (event) => {
          const button = event.target.closest('[data-filter]');
          if (!button) return;
          const key = group.dataset.filterGroup;
          state[key] = button.dataset.filter;
          group.querySelectorAll('[data-filter]').forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-pressed', String(active));
          });
          update();
        });
      });
      reset.addEventListener('click', resetAll);
      emptyReset.addEventListener('click', resetAll);
    });
  };
  initializeResourceLibraries();
  document.addEventListener('shopify:section:load', initializeResourceLibraries);

  } catch(e) { console.error(e); }
})();
})();
